import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ac1124f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper-circle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Circle = _resolveComponent("Circle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (step, index) => {
      return (_openBlock(), _createBlock(_component_Circle, {
        class: "circle",
        key: index,
        color: step ? '#64380c' : '#b29475',
        height: "20",
        width: "20"
      }, null, 8, ["color"]))
    }), 128))
  ]))
}